// import VueInfiniteViewer from './VueInfiniteViewer';
import InfiniteViewer from './InfiniteViewer.vue';

export default InfiniteViewer;
export { InfiniteViewer as VueInfiniteViewer };
